window.Reverb = window.Reverb || {};

Reverb.BlogSearch = (function () {
  const activeClass = 'search-active';


  const userTypingClass = 'user-typing';


  let isDesktop = true;


  let clickEvent = 'click';


  const blogNavigation = '.blog-navigation';


  const blogSearch = '.search';


  const blogSearchField = '.search input';


  const cancelSearchBtn = '.search-cancel';

  function init() {
    clickEvent = Reverb.MobileDetection.getClickEvent();
    isDesktop = !Reverb.MobileDetection.isMobileBrowser();

    $(blogSearch).on(clickEvent, activateSearch);
    $(cancelSearchBtn).on(clickEvent, cancelSearch);
    $(blogSearchField).on('blur', deactivateSearch);
  }

  function activateSearch() {
    const BlogNav = Reverb.MobileNavigation;

    $(blogNavigation).addClass(activeClass);

    if (BlogNav.isMobileDropdownActive()) BlogNav.toggleMobileDropdown();
    if (isDesktop) $(blogNavigation).find(blogSearchField).trigger('focus');
  }

  function deactivateSearch() {
    if ($(blogSearchField).val().length > 0) return false; // stop function
    $(blogNavigation).removeClass(activeClass);
  }

  function cancelSearch() {
    $(blogSearchField).val('').trigger('blur');
  }

  return {
    init,
  };
}());

$(Reverb.BlogSearch.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/blog/blog_search.js